import styled from 'styled-components';

import { ModalBody } from 'ui/modal';
import { BasicOption } from 'ui/selects';
import { TextArea } from 'ui/inputs';
import { colors, spacing, fontWeights, Label, caption, body2, heading4, subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

/* ---------- SHARED STYLES ---------- */
export const StyledBody = styled(ModalBody)`
  display: flex;
  justify-content: space-between;
`;

/* ---------- CREATE MODAL ---------- */
export const StyledTextArea = styled(TextArea)`
  > textarea {
    height: ${pxToRem(200)};
  }
`;

export const FragmentDetails = styled.div`
  margin-right: ${spacing.plusHalf};
  width: 100%;
`;

export const TilesetText = styled.p`
  ${caption}
  color: ${colors.secondaryText};
`;

export const FormField = styled.div`
  margin-bottom: ${spacing.base};
`;

export const StyledLabel = styled(Label)`
  margin-bottom: ${spacing.half};

  span {
    font-weight: ${fontWeights.regular};
  }
`;

/* ---------- SELECT MODAL ---------- */
export const StyledContent = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
`;

export const RetryLink = styled.span`
  margin-left: ${spacing.eighth};
  cursor: pointer;
  text-decoration: underline;
`;

export const TilesetSelection = styled.div`
  padding-right: ${spacing.plusHalf};
  margin-right: ${spacing.plusHalf};
  width: 100%;
  border-right: ${spacing.single} solid ${colors.borderPrimary};
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  min-height: ${pxToRem(550)};
  min-width: ${pxToRem(280)};
  overflow: hidden;
`;

export const TilesetOptionContainer = styled.div`
  overflow-y: auto;
  height: 100%;
`;

export const TilesetOption = styled(BasicOption)<{ isSelected?: boolean }>`
  ${body2}
  cursor: pointer;
  margin-bottom: ${spacing.quarter};

  ${({ isSelected }) =>
    isSelected &&
    `
    :not(:hover) {
      color: ${colors.textLink};
    }
  `}
`;

export const RightSideContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const DeleteTileset = styled.div`
  display: flex;
  gap: ${spacing.threeQuarter};
  align-items: center;
`;

export const TilesetDetails = styled.div`
  ${subtitle2}
  background-color: ${colors.grey1};
  padding: ${spacing.base};
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const TilesetDetail = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(148)} 1fr;
`;

export const TilesetTitle = styled.p`
  ${heading4}
`;
export const TilesetDescription = styled.p`
  ${caption}
  color: ${colors.textSecondary};
`;

export const CreatedBy = styled.span`
  ${body2}
  color: ${colors.textSecondary};
  display: flex;
  flex-direction: column;
`;

export const CreatedByUser = styled.div`
  display: flex;
  gap: ${spacing.half};
  height: ${spacing.plusHalf};
`;
